export default __webpack_public_path__ + "static-json/ne_50m_graticules_30-467b0ce31fd334c52ed32114541fef47.json";